import React from 'react';
import { ExternalLink } from 'lucide-react';
import styles from './DataIntegrationHelpRail.module.css';

const DOCS_BASE = 'https://docs.embedreach.com';

const EYEBROW = 'Set up your integration';

interface ResourceLink {
  title: string;
  description: string;
  href: string;
}

const RESOURCE_LINKS: ResourceLink[] = [
  {
    title: 'Plan your automations',
    description: "Start from a tenant's goal and work backward to the data you need",
    href: `${DOCS_BASE}/onboarding/planning/engage-automations`,
  },
  {
    title: 'How Reach models your data',
    description: 'The three core concepts and how your data maps to them',
    href: `${DOCS_BASE}/data-sharing/data-model`,
  },
  {
    title: 'Custom schemas',
    description: 'JSON Schema format, references between schemas, and PII annotations',
    href: `${DOCS_BASE}/data-sharing/custom-schemas`,
  },
  {
    title: 'Schema API reference',
    description: 'Create and update schema definitions via the API',
    href: `${DOCS_BASE}/api-reference/endpoint/post-partner-schema-definitions`,
  },
  {
    title: 'Data sync setup',
    description: 'Step-by-step onboarding for your integration',
    href: `${DOCS_BASE}/onboarding/data-sync-setup`,
  },
];

// Static documentation links for the Data Integration settings page, shown as a side rail.
export const DataIntegrationHelpRail: React.FC = () => {
  return (
    <aside className={styles.rail}>
      <div className={styles.eyebrow}>{EYEBROW}</div>
      <nav className={styles.links}>
        {RESOURCE_LINKS.map(link => (
          <a
            key={link.title}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.link}>
            <span className={styles.titleRow}>
              <span className={styles.title}>{link.title}</span>
              <ExternalLink size={12} />
            </span>
            <span className={styles.description}>{link.description}</span>
          </a>
        ))}
      </nav>
    </aside>
  );
};
